const COMMON_FETCH_CUISINE_TYPES = {
  START: 'START_COMMON_FETCH_CUISINE_TYPES',
  COMPLETE: 'COMPLETE_COMMON_FETCH_CUISINE_TYPES',
  FAIL: 'FAIL_COMMON_FETCH_CUISINE_TYPES',
  CLEANUP: 'CLEANUP_COMMON_FETCH_CUISINE_TYPES',
}

export default COMMON_FETCH_CUISINE_TYPES
